import React from 'react'
import injectSheet from 'react-jss'
import styles from './form-row.styles.js'
import classNames from 'classnames'

const FormRow = ({ classes, children, first, className }) => (
  <div
    className={classNames(classes.row, { [classes.first]: first }, className)}>
    {children}
  </div>
)

export default injectSheet(styles)(FormRow)
